import { render } from "./CheckboxInput.vue?vue&type=template&id=2ab280c8&scoped=true"
import script from "./CheckboxInput.vue?vue&type=script&lang=js"
export * from "./CheckboxInput.vue?vue&type=script&lang=js"

import "./CheckboxInput.vue?vue&type=style&index=0&id=2ab280c8&scoped=true&lang=css"

import exportComponent from "/home/d6338/zsurvey-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab280c8"]])

export default __exports__